if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelector('.product-media-modal__dialog')?.addEventListener('pointerup', (event) => {
          event.stopPropagation();
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.enableImageZoom();
      }

      showActiveMedia() {
        this.querySelectorAll('.product-media-modal__content.is-zoomed').forEach((element) => {
          element.classList.remove('is-zoomed');
        });
        this.querySelectorAll('.product-media-modal__image').forEach((image) => {
          image.style.removeProperty('width');
        });
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      enableImageZoom() {
        const container = this.querySelector('.product-media-modal__content');
        if (!container || container.dataset.zoomReady === 'true') return;

        container.dataset.zoomReady = 'true';
        container.addEventListener('click', (event) => {
          const image = event.target.closest('.product-media-modal__image.active');
          if (!image) return;

          event.preventDefault();
          const wasZoomed = container.classList.contains('is-zoomed');
          const imageRect = image.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          const focusX = imageRect.width ? (event.clientX - imageRect.left) / imageRect.width : 0.5;
          const focusY = imageRect.height ? (event.clientY - imageRect.top) / imageRect.height : 0.5;
          const pointerOffsetX = event.clientX - containerRect.left;
          const pointerOffsetY = event.clientY - containerRect.top;

          container.classList.toggle('is-zoomed');

          if (!wasZoomed && container.classList.contains('is-zoomed')) {
            if (image.naturalWidth) image.style.width = `${image.naturalWidth}px`;
            requestAnimationFrame(() => {
              container.scrollLeft = Math.max(focusX * image.scrollWidth - pointerOffsetX, 0);
              container.scrollTop = Math.max(focusY * image.scrollHeight - pointerOffsetY, 0);
            });
          } else {
            image.style.removeProperty('width');
          }
        });
      }
    }
  );
}
